import { useQuery } from "@apollo/client";
import type { Agent } from "@casey/db-types";
import { GET_TEMPLATE_BY_ID } from "../gql";

interface TemplateVariables {
  id: string;
}

interface TemplateResponse {
  agent: Agent;
}

export function useTemplate(id: string) {
  const { data, loading, error, refetch } = useQuery<
    TemplateResponse,
    TemplateVariables
  >(GET_TEMPLATE_BY_ID, {
    variables: { id },
    skip: !id,
    errorPolicy: "all",
  });

  return {
    template: data?.agent || null,
    loading,
    error,
    refetch,
  };
}
